module.exports = __webpack_public_path__ + "static/media/steak.aa33ee46.svg";